import { render, staticRenderFns } from "./HomeDataTableHub.vue?vue&type=template&id=152aeaf4&scoped=true&"
import script from "./HomeDataTableHub.vue?vue&type=script&lang=js&"
export * from "./HomeDataTableHub.vue?vue&type=script&lang=js&"
import style0 from "./HomeDataTableHub.vue?vue&type=style&index=0&id=152aeaf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152aeaf4",
  null
  
)

export default component.exports